import http from './http';
import { listResource } from './listResource';

// Listar ejercicios con paginación, búsqueda y ordenamiento
export async function listExercises(options = {}) {
  return listResource('/exercises', options);
}

// Activar/Desactivar Ejercicio
export const updateExerciseStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/exercises/${id}/status`, { is_active: isActive });

// Eliminar Ejercicio
export const deleteExercise = (id) => http.delete(`/exercises/${id}`);

// Obtener un ejercicio por su ID
export async function getExerciseById(id) {
  const res = await http.get(`/exercises/${id}`);
  return res.data?.data ?? res.data;
}

// Crear un nuevo ejercicio
export async function createExercise(payload) {
  const res = await http.post('/exercises', payload);
  return res.data?.data ?? res.data;
}

// Actualizar un ejercicio existente
export async function updateExercise(id, payload) {
  const res = await http.put(`/exercises/${id}`, payload);
  return res.data?.data ?? res.data;
}

// Subir archivo de imagen/video para ejercicio
export async function uploadExerciseMedia(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/files/upload/exercise', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

// Verificar si un título ya existe
export async function checkTitleExists(title, excludeId = null) {
  try {
    const { items } = await listExercises({ search: title });
    const exists = items?.some(
      (exercise) =>
        exercise.title?.toLowerCase() === title?.toLowerCase() &&
        exercise.id !== excludeId
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar título:', error);
    return false;
  }
}

// Obtener ejercicios alternativos de un ejercicio
export async function getExerciseAlternatives(exerciseId) {
  const res = await http.get(`/exercises/${exerciseId}/alternatives`);
  return res.data?.items ?? res.data ?? [];
}

// Obtener ejercicios alternativos disponibles
export async function getAvailableAlternatives(options = {}) {
  const { exerciseId, typeCode } = options;
  const params = {};

  if (exerciseId) {
    params.exercise_id = exerciseId;
  }
  if (typeCode) {
    params.type_code = typeCode;
  }

  const res = await http.get(`/exercises/available-alternatives`, { params });
  return res.data?.items ?? res.data ?? [];
}

export async function uploadExerciseAudio(file) {
  const formData = new FormData();
  formData.append('audio', file);

  const res = await http.post('/files/upload/audio', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

export async function listExercisesVariants(options = {}) {
  const res = await http.get(`/exercises/variants`, { params: options });
  return res.data?.items ?? res.data ?? [];
}